import React from "react";

const SliderImageBox = ({ views, images }) => {
  return (
    <div className="col-md-12 product-slier-details">
      <ul id="lightSlider">
        {images &&
          images.map((image) => {
            return (
              <>
                <li data-thumb={image} style={{ padding: 20 }}>
                  <img
                    className="figure-img img-fluid"
                    src={image}
                    style={{ height: 400, width: 200 }}
                    alt="product-img"
                  />
                </li>
              </>
            );
          })}
      </ul>
    </div>
  );
};

export default SliderImageBox;
